module.exports = __webpack_public_path__ + "img/surflogo.5bb370c7.png";